import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import queryString from 'query-string';

import 'bootstrap/dist/css/bootstrap.min.css';

const qs = queryString.parse(window.location.search);

ReactDOM.render(<App filterFile={qs.filter} dataFile={qs.data} />, document.getElementById('root'));
